var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187506",
    "data-name": "Group 187506",
    transform: "translate(-325.009 -266.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325.009 266.26)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187414",
    "data-name": "Group 187414",
    transform: "translate(336.587 274.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17912",
    "data-name": "Path 17912",
    d: "M109.04,25.226a1.771,1.771,0,0,1,1.12-1.42,3.879,3.879,0,0,1,.946-.169c.119-.014.181-.037.229-.156a1.935,1.935,0,0,1,3.587-.006c.066.17.173.156.3.157a1.91,1.91,0,0,1,1.9,1.236c.042.113.068.232.11.375h.253c.851,0,1.7,0,2.553,0a1.384,1.384,0,0,1,1.522,1.5q0,8.665,0,17.33a1.378,1.378,0,0,1-1.5,1.5q-6.93,0-13.859,0a1.378,1.378,0,0,1-1.5-1.491q0-8.677,0-17.354a1.376,1.376,0,0,1,1.491-1.481c.924,0,1.848,0,2.772,0a.584.584,0,0,0,.078-.015M105.6,35.411q0,4.271,0,8.542c0,.576.126.7.7.7h13.663a1.849,1.849,0,0,0,.267-.007.434.434,0,0,0,.409-.383,2.1,2.1,0,0,0,.02-.313q0-8.542,0-17.084c0-.065,0-.13,0-.194a.48.48,0,0,0-.541-.516c-.956,0-1.912,0-2.869,0a.3.3,0,0,0-.222.123,1.872,1.872,0,0,1-1.681.98c-1.466.021-2.934.017-4.4,0a1.9,1.9,0,0,1-1.693-.964.36.36,0,0,0-.262-.141c-.9-.01-1.8-.006-2.7-.006-.556,0-.689.132-.689.686q0,4.283,0,8.566m7.522-9.053v0c.721,0,1.442,0,2.163,0a.914.914,0,1,0,0-1.813c-.21-.006-.421.005-.632,0-.33-.014-.454-.139-.525-.458a1.381,1.381,0,0,0-.189-.513.973.973,0,0,0-1.085-.357.9.9,0,0,0-.723.787c-.068.441-.2.54-.646.544-.227,0-.455-.007-.68.012a.913.913,0,0,0-.843,1.1.972.972,0,0,0,.946.7c.737.009,1.474,0,2.211,0",
    transform: "translate(-104.697 -22.27)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17914",
    "data-name": "Path 17914",
    d: "M251.744,50.27c-.737,0-1.474.007-2.211,0a.972.972,0,0,1-.946-.7.913.913,0,0,1,.843-1.1c.225-.019.453-.011.68-.012.45,0,.578-.1.646-.544a.9.9,0,0,1,.723-.787.973.973,0,0,1,1.085.357,1.38,1.38,0,0,1,.189.513c.072.319.2.444.526.458.21.009.421,0,.632,0a.914.914,0,1,1,0,1.813c-.721.006-1.442,0-2.163,0Z",
    transform: "translate(-243.315 -46.181)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17916",
    "data-name": "Path 17916",
    d: "M185.553,485.481h-5.032a1.355,1.355,0,0,1-.266-.016.436.436,0,0,1-.367-.447.42.42,0,0,1,.359-.426,1.474,1.474,0,0,1,.289-.025h10.087c.041,0,.081,0,.122,0,.325.014.523.185.526.453s-.2.459-.541.459q-2.589,0-5.177,0",
    transform: "translate(-177.145 -467.706)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17917",
    "data-name": "Path 17917",
    d: "M185.555,560.623h-5.031c-.434,0-.644-.146-.647-.447s.207-.456.637-.456h10.111a1.857,1.857,0,0,1,.218.009.445.445,0,0,1-.015.888c-.08.007-.162.006-.243.006h-5.031",
    transform: "translate(-177.135 -540.119)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17918",
    "data-name": "Path 17918",
    d: "M234.623,409.717h4.132a1.367,1.367,0,0,1,.29.019.435.435,0,0,1,.345.441.416.416,0,0,1-.335.42,1.232,1.232,0,0,1-.288.031q-4.156,0-8.312,0a1.254,1.254,0,0,1-.217-.015.448.448,0,0,1,.06-.894c.4-.009.81,0,1.215,0h3.111",
    transform: "translate(-225.265 -395.585)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17919",
    "data-name": "Path 17919",
    d: "M180.779,410.3a.449.449,0,1,1-.444-.45.457.457,0,0,1,.444.45",
    transform: "translate(-177.139 -395.717)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17920",
    "data-name": "Path 17920",
    d: "M207.463,238.913h-.982c0-.264,0-.513,0-.762a.493.493,0,0,0-.55-.559c-.243-.007-.486-.007-.728-.01-.006,0-.013-.009-.035-.027v-.945c.249,0,.489,0,.73,0,.409,0,.578-.169.583-.573,0-.241,0-.482,0-.74h.982c0,.247,0,.487,0,.727,0,.415.176.582.6.585.234,0,.469,0,.721,0v.982c-.243,0-.482,0-.722,0-.418,0-.591.175-.6.588,0,.24,0,.481,0,.733",
    transform: "translate(-201.503 -227.528)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/disclaimer.55dfd68751a079e91bf09a63b901bdc0.svg";
export { ForwardRef as ReactComponent };